export default __webpack_public_path__ + "cfb29a508637ddadb420e876587ee163.png";